// extracted by mini-css-extract-plugin
module.exports = {"container":"zTgN9lseeQep2SURwvxfL","heading":"_1BNxKNDSjcnzHozmhdajJZ","requiredLabel":"_1yDzyefrplQVgWLGodOqVe","items":"_3B39Q2FPPSalRsd0qeS6L1"};